import React, { useState, useEffect } from 'react';
import { OtService } from '../services/OtService';
import { ControlAdministrativoOT } from './ControlAdministrativoOT';

export const PanelAdministrativoPagos: React.FC = () => {
    const [ordenes, setOrdenes] = useState<any[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const getFirstDayOfMonth = () => {
        const date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
    };
    const getToday = () => new Date().toISOString().split('T')[0];

    const [fechaInicio, setFechaInicio] = useState<string>(getFirstDayOfMonth());
    const [fechaFin, setFechaFin] = useState<string>(getToday());
    const [searchTaller, setSearchTaller] = useState("");

    const [filterEmptyFiles, setFilterEmptyFiles] = useState(false);

    const [modalOrdenId, setModalOrdenId] = useState<string | null>(null);

    const [showGlobalModal, setShowGlobalModal] = useState(false);
    const [folioGlobal, setFolioGlobal] = useState("");
    const [archivosFacturaGlobal, setArchivosFacturaGlobal] = useState<File[]>([]);
    const [marcarPagadoGlobal, setMarcarPagadoGlobal] = useState(false);
    const [archivosPagoGlobal, setArchivosPagoGlobal] = useState<File[]>([]);
    const [isSavingGlobal, setIsSavingGlobal] = useState(false);

    const cargarOrdenes = async () => {
        if (fechaInicio > fechaFin) return;
        setIsLoading(true);
        try {
            const data = await OtService.fetchOrdenesAdministrativas(fechaInicio, fechaFin, searchTaller);
            setOrdenes(data);
            setSelectedIds([]);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (fechaInicio && fechaFin && fechaInicio <= fechaFin) {
            cargarOrdenes();
        }
    }, [fechaInicio, fechaFin]);

    const ordenesFiltradas = ordenes.filter(ot => filterEmptyFiles ? Number(ot.cantidad_archivos) === 0 : true);

    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setSelectedIds(ordenesFiltradas.filter(o => o.is_facturado == 0 || o.is_pagado == 0).map(o => o.clave_orden_trabajo));
        } else {
            setSelectedIds([]);
        }
    };

    const toggleSelection = (id: number) => {
        setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    const handleFacturarGlobal = async () => {
        if (!folioGlobal || archivosFacturaGlobal.length === 0) {
            alert("El folio y el archivo de factura (PDF/XML) son obligatorios."); return;
        }
        setIsSavingGlobal(true);
        try {
            await OtService.saveFacturaGlobal(selectedIds, folioGlobal, archivosFacturaGlobal, marcarPagadoGlobal, archivosPagoGlobal);
            setShowGlobalModal(false);
            setFolioGlobal(""); setArchivosFacturaGlobal([]);
            setMarcarPagadoGlobal(false); setArchivosPagoGlobal([]);
            cargarOrdenes();
            alert("Operación en lote aplicada con éxito.");
        } catch (error: any) {
            alert(error.message || "Error al procesar el lote.");
        } finally {
            setIsSavingGlobal(false);
        }
    };

    const granTotalLote = ordenesFiltradas.filter(o => selectedIds.includes(o.clave_orden_trabajo)).reduce((acc, curr) => acc + Number(curr.monto_pagado), 0);

    return (
        <div className="container-fluid py-4">
            <h2 className="mb-4"><i className="fas fa-file-invoice-dollar text-primary me-2"></i> Facturación y Pagos Consolidada</h2>

            <div className="card shadow-sm mb-4 border-0">
                <div className="card-body rounded d-flex gap-3 align-items-end flex-wrap">
                    <div>
                        <label className="small fw-bold text-muted" htmlFor="fechaInicio">Fecha Inicio</label>
                        <input type="date" id="fechaInicio" className="form-control shadow-sm" value={fechaInicio} max={fechaFin} onChange={(e) => setFechaInicio(e.target.value)} />
                    </div>
                    <div>
                        <label className="small fw-bold text-muted" htmlFor="fechaFin">Fecha Fin</label>
                        <input type="date" id="fechaFin" className="form-control shadow-sm" value={fechaFin} min={fechaInicio} onChange={(e) => setFechaFin(e.target.value)} />
                    </div>

                    <div className="flex-grow-1">
                        <label className="small fw-bold text-muted">Búsqueda (Folio, RFC, Serie, Placa)</label>
                        <div className="input-group shadow-sm">
                            <input type="text" className="form-control" placeholder="Buscar..." value={searchTaller} onChange={(e) => setSearchTaller(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && cargarOrdenes()} />
                            <button className="btn btn-primary" onClick={cargarOrdenes} disabled={isLoading || fechaInicio > fechaFin}>
                                <i className="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>

                    <div className="d-flex align-items-center mb-1 ms-2">
                        <div className="form-check form-switch fs-5">
                            <input className="form-check-input cursor-pointer" type="checkbox" id="flexSwitchEmptyFiles" checked={filterEmptyFiles} onChange={(e) => setFilterEmptyFiles(e.target.checked)} />
                            <label className="form-check-label small fw-bold text-muted ms-2 mt-1 cursor-pointer" htmlFor="flexSwitchEmptyFiles">
                                Ver órdenes sin archivos
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            {selectedIds.length > 0 && (
                <div className="alert alert-info shadow-sm d-flex justify-content-between align-items-center animate__animated animate__fadeInDown">
                    <span><strong>{selectedIds.length}</strong> órdenes seleccionadas. Suma autorizada: <strong>${granTotalLote.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</strong></span>
                    <button className="btn btn-success fw-bold shadow-sm" onClick={() => setShowGlobalModal(true)}>
                        <i className="fas fa-layer-group me-2"></i> Procesar Selección Global
                    </button>
                </div>
            )}

            <div className="card shadow-sm border-0">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead>
                            <tr>
                                <th className="text-center">
                                    <input type="checkbox" className="form-check-input" style={{ borderColor: 'gray', cursor: 'pointer' }} onChange={handleSelectAll} checked={selectedIds.length > 0 && selectedIds.length === ordenesFiltradas.filter(o => o.is_facturado == 0 || o.is_pagado == 0).length} />
                                </th>
                                <th>OT Folio</th>
                                <th>Bien</th>
                                <th>Taller (RFC)</th>
                                <th>F. Alta / Term.</th>
                                <th className="text-end">Monto Total</th>
                                <th className="text-center">Archivos</th>
                                <th>Estatus Financiero</th>
                                <th className="text-center">Detalle</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? <tr><td colSpan={9} className="text-center py-5"><div className="spinner-border text-primary"></div></td></tr> :
                                ordenesFiltradas.length === 0 ? <tr><td colSpan={9} className="text-center py-5 text-muted">No se encontraron órdenes con los filtros actuales.</td></tr> :
                                    ordenesFiltradas.map(ot => (
                                        <tr key={ot.clave_orden_trabajo} className={selectedIds.includes(ot.clave_orden_trabajo) ? 'table-selected' : ''}>
                                            <td className="text-center">
                                                <input type="checkbox" className="form-check-input" style={{ borderColor: 'gray', cursor: 'pointer' }} disabled={ot.is_facturado == 1 && ot.is_pagado == 1} checked={selectedIds.includes(ot.clave_orden_trabajo)} onChange={() => toggleSelection(ot.clave_orden_trabajo)} />
                                            </td>
                                            <td><strong>{ot.folio}</strong></td>
                                            <td>{ot.nombre_bien}<br /><small className="text-muted">{ot.numero_serie} - {ot.placa}</small></td>
                                            <td>{ot.taller}<br /><small className="text-muted">{ot.rfc}</small></td>
                                            <td><small className="d-block text-muted">Alta: {ot.fecha_alta.split(' ')[0]}</small><small>Fin: {ot.fecha_terminacion ? ot.fecha_terminacion.split(' ')[0] : 'En taller'}</small></td>
                                            <td className="text-end fw-bold">${Number(ot.monto_pagado).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>

                                            <td className="text-center">
                                                <span className={`badge ${ot.cantidad_archivos > 0 ? 'bg-primary' : 'bg-danger'}`}>
                                                    <i className="fas fa-paperclip me-1"></i> {ot.cantidad_archivos}
                                                </span>
                                            </td>

                                            <td>
                                                <div className="d-flex gap-1 flex-column">
                                                    {ot.is_facturado == 1 ? <span className="badge bg-success w-100"><i className="fas fa-check"></i> Facturado</span> : <span className="badge bg-secondary w-100">Pend. Factura</span>}
                                                    {ot.is_pagado == 1 ? <span className="badge bg-success w-100"><i className="fas fa-check"></i> Pagado</span> : <span className="badge bg-secondary w-100">Pend. Pago</span>}
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <button className="btn btn-sm btn-outline-primary" onClick={() => setModalOrdenId(ot.clave_orden_trabajo)}>
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            {modalOrdenId && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Gestión Individual de OT</h5>
                                <button type="button" className="btn-close" onClick={() => { setModalOrdenId(null); cargarOrdenes(); }}></button>
                            </div>
                            <div className="modal-body">
                                <ControlAdministrativoOT ordenId={modalOrdenId} />
                            </div>
                        </div>
                    </div>
                </div>
            )
            }

            {
                showGlobalModal && (
                    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
                        <div className="modal-dialog modal-xl modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header bg-primary">
                                    <h5 className="modal-title"><i className="fas fa-layer-group me-2"></i> Procesar Lote ({selectedIds.length} Ordenes de Trabajo)</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowGlobalModal(false)}></button>
                                </div>
                                <div className="modal-body p-4">
                                    <div className="alert alert-info shadow-sm">
                                        <div className="d-flex justify-content-between">
                                            <span className="fw-bold">Total del Lote (Autorizado):</span>
                                            <span className="fs-5 fw-bold text-success">${granTotalLote.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
                                        </div>
                                        <hr className="my-2" />
                                        <small>La factura y el comprobante de pago que ingreses se vinculará automáticamente al expediente de todas las órdenes seleccionadas.</small>
                                    </div>

                                    <div className="row g-4 mt-2">
                                        {/* Facturación */}
                                        <div className="col-md-6 border-end pe-md-4">
                                            <h6 className="fw-bold text-secondary border-bottom pb-2">1. Facturación (Obligatorio)</h6>
                                            <div className="form-group mb-3 mt-3">
                                                <label className="fw-bold small mb-1">Folio Factura Global *</label>
                                                <input type="text" className="form-control" value={folioGlobal} onChange={(e) => setFolioGlobal(e.target.value)} placeholder="Ej. FAC-ABRIL" required />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label className="fw-bold small mb-1">Cargar PDF y XML *</label>
                                                <input type="file" className="form-control form-control-sm" multiple accept=".pdf,.xml" onChange={(e) => setArchivosFacturaGlobal(Array.from(e.target.files || []))} />
                                            </div>
                                        </div>

                                        {/* Pagos */}
                                        <div className="col-md-6 ps-md-4">
                                            <h6 className="fw-bold text-secondary border-bottom pb-2">2. Pago de la Factura (Opcional)</h6>

                                            <div className="form-check form-switch fs-6 mb-3 mt-3">
                                                <input className="form-check-input cursor-pointer" type="checkbox" role="switch" id="pagarLoteCheck" checked={marcarPagadoGlobal} onChange={(e) => setMarcarPagadoGlobal(e.target.checked)} />
                                                <label className={`form-check-label fw-bold ms-2 ${marcarPagadoGlobal ? 'text-success' : 'text-muted'}`} htmlFor="pagarLoteCheck">
                                                    {marcarPagadoGlobal ? "MARCAR COMO PAGADAS" : "Dejar pendiente de pago"}
                                                </label>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label className={`fw-bold small mb-1 ${!marcarPagadoGlobal ? 'text-muted' : ''}`}>Comprobante de Pago (Opcional)</label>
                                                <input type="file" className="form-control form-control-sm" multiple accept="image/*,application/pdf" disabled={!marcarPagadoGlobal} onChange={(e) => setArchivosPagoGlobal(Array.from(e.target.files || []))} />
                                                <small className="text-muted fst-italic">Solo activo si se marca la casilla superior.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowGlobalModal(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-primary fw-bold shadow-sm px-4" onClick={handleFacturarGlobal} disabled={isSavingGlobal}>
                                        {isSavingGlobal ? <><i className="fas fa-spinner fa-spin me-2"></i> Procesando...</> : 'Procesar Lote Global'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >

    );
};
export default PanelAdministrativoPagos;